import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9995ed6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "prize"
};
const _hoisted_2 = {
  class: "log"
};
const _hoisted_3 = {
  class: "marquee"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lb"
}, [/*#__PURE__*/_createElementVNode("span", null, "现场直播提示:")], -1));
const _hoisted_5 = {
  class: "contont"
};
const _hoisted_6 = {
  key: 0,
  class: "video"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin-top": "-25px"
  }
}, "快乐8彩搅珠直播视频播放时间为每晚", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "brown"
  }
}, " 21:32-21.38"), /*#__PURE__*/_createTextVNode(" （北京时间），敬请查看")], -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  key: 1,
  class: "videos"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://kj.49six.net:1888/?kl8",
  frameborder: "0"
}, null, -1));
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  class: "result"
};
const _hoisted_14 = {
  class: "hisWrapper"
};
const _hoisted_15 = {
  class: "liveHisList"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "liveThumb"
}, [/*#__PURE__*/_createElementVNode("img", {
  "data-v-1bc3c0f3": "",
  src: "https://00853six.com/assets/repeat-25fbfe0d.png"
})], -1));
const _hoisted_18 = {
  class: "liveDesc"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "快乐8彩", -1));
const _hoisted_20 = {
  "data-v-1bc3c0f3": ""
};
const _hoisted_21 = {
  key: 0,
  class: "popPlayer"
};
const _hoisted_22 = {
  class: "pmain"
};
const _hoisted_23 = {
  class: "pheader"
};
const _hoisted_24 = {
  class: "pinfo"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "快乐8彩", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "回放", -1));
const _hoisted_27 = {
  class: "pcode"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "開獎號碼：", -1));
const _hoisted_29 = {
  class: "drawCode"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1025 1024",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M513.344 0a512 512 0 1 0 0 1024 512 512 0 0 0 0-1024zm226.048 674.624l-54.528 56.896-171.52-164.928L341.952 731.52l-54.592-56.896L456.576 512 287.36 349.312l54.592-56.768 171.392 164.8 171.52-164.8 54.528 56.768L570.176 512l169.216 162.624z"
})], -1));
const _hoisted_31 = [_hoisted_30];
const _hoisted_32 = {
  class: "video-flv"
};
const _hoisted_33 = ["src"];
import nav_header from '@/components/nav_header.vue';
import result from '@/components/priz_result.vue';
import axios from 'axios';
import { onBeforeMount, ref } from 'vue';

import { reactive, toRefs } from 'vue';
export default {
  __name: 'prize',
  setup(__props) {
    let data = reactive({
      show: false,
      videoData: [],
      videInfo: {}
    });
    let yearsb = ref(null);
    onBeforeMount(() => {
      var datesc = new Date();
      let year = datesc.getFullYear();
      yearsb.value = datesc.getFullYear();
      let url = `https://jl.tukuapi.com/api/get_record?year=&lottery_id=${6}`;
      axios.get(url).then(res => {
        let datas = res.data.data;
        data.videoData.push(...datas);
      });
    });
    let {
      show,
      videoData,
      videInfo
    } = toRefs(data);
    let viewshow = item => {
      data.show = !data.show;
      item.open_number = item.open_number.split(",");
      item.sx = item.sx.split(",");
      item.color = item.color.split(",");
      item.url = `https://sp.99988.finance/lottery/video/${item.year}/2032/${item.year}${item.periods}.mp4`;
      data.videInfo = item;
    };
    let pclose = () => {
      data.show = !data.show;
    };
    let numarrays = [[1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46], [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48], [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]];
    let cons = (d, array) => {
      let b = 0;
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < array[i].length; j++) {
          if (array[i][j] == d) {
            b = i;
          }
        }
      }
      return b;
    };
    let colorarray = ['blue', 'green', 'red'];
    let shows = ref(true);
    setInterval(() => {
      getDate({
        Time: '21:33'
      });
    }, 1000);
    const getDate = data => {
      // var oDate = new Date();//获取日期对象
      // var oldTime = oDate.getTime();//现在距离1970年的毫秒数
      // var newDate = new Date(`${data.Year}/${data.Moon}/${data.Day} ${data.Time}:00 GMT+08:00`);
      // var newTime = newDate.getTime();//2019年距离1970年的毫秒数
      let c = data.Time.split(':');
      let t = c[0] * 3600 + c[1] * 60;
      let nh = new Date().getUTCHours() + 8;
      let nm = new Date().getMinutes();
      let ns = new Date().getSeconds();
      let nt = nh * 3600 + nm * 60 + ns;
      let dt = nt < t ? t - nt : 24 * 3600 + t - nt;
      let dh = Math.floor(dt / 3600);
      if (dh < 10) {
        dh = '0' + dh;
      }
      let dm = Math.floor(dt % 3600 / 60);
      if (dm < 10) {
        dm = '0' + dm;
      }
      let ds = dt % 3600 % 60;
      if (ds < 10) {
        ds = '0' + ds;
      }
      console.log(dh, dm);
      if (dh == 23 && dm > 54) {
        shows.value = false;
      } else {
        shows.value = true;
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_marquee = _resolveComponent("marquee");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(nav_header, {
        name: "开奖现场"
      }, {
        more: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
          to: "/record"
        }, {
          default: _withCtx(() => [_createTextVNode(" 历史记录 ")]),
          _: 1
        })])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_marquee, {
        direction: "left"
      }, {
        default: _withCtx(() => [_createTextVNode(" 同步播报中央电视台1套视频，开奖过程100%公开公正！ ")]),
        _: 1
      })])]), _unref(shows) ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)) : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)), _createElementVNode("div", _hoisted_13, [_createVNode(result)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(videoData), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "liveItem",
          onClick: $event => _unref(viewshow)(item),
          key: index
        }, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", null, [_createTextVNode("第 "), _createElementVNode("b", _hoisted_20, _toDisplayString(item.year + item.periods), 1), _createTextVNode(" 期 開獎視頻")])])], 8, _hoisted_16);
      }), 128))])]), _unref(show) ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", null, [_hoisted_25, _createTextVNode("第"), _createElementVNode("b", null, _toDisplayString(_unref(videInfo).year + _unref(videInfo).periods), 1), _createTextVNode("期"), _hoisted_26])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("ul", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(videInfo).open_number, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(_unref(videInfo).color[index]),
          key: index
        }, [_createElementVNode("strong", null, _toDisplayString(item), 1), _createElementVNode("em", null, _toDisplayString(_unref(videInfo).sx[index]), 1)], 2);
      }), 128))])]), _createElementVNode("div", {
        class: "pclose",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(pclose) && _unref(pclose)(...args))
      }, _hoisted_31)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("video", {
        autoplay: "",
        src: _unref(videInfo).url
      }, null, 8, _hoisted_33)])])])) : _createCommentVNode("", true)], 64);
    };
  }
};